import { render, staticRenderFns } from "./Domicilio.vue?vue&type=template&id=3a0f5e42&scoped=true&lang=html&"
import script from "./Domicilio.vue?vue&type=script&lang=js&"
export * from "./Domicilio.vue?vue&type=script&lang=js&"
import style0 from "./Domicilio.vue?vue&type=style&index=0&id=3a0f5e42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0f5e42",
  null
  
)

export default component.exports